import { useMemo } from 'react'

import getFormattedAmountAndDuration from '../helpers/tariff.helpers'

import { TimeUnit } from '~/basket/model/common/duration.model'
import { Price } from '~/basket/model/common/price.model'

export default function useMainPriceOfCard({
  price,
  isOnlyPrice,
}: {
  price?: Price
  isOnlyPrice: boolean
}) {
  function getDecimalPart(number: number) {
    const roundedNumber = number.toFixed(2).toString()
    return roundedNumber.split('.')
  }

  const [integer, decimal] = useMemo(() => getDecimalPart(price ? price.value : 0), [price])

  const amountAndDuration = useMemo(
    () =>
      getFormattedAmountAndDuration(
        price?.duration?.amount || 0,
        price?.duration.unit || TimeUnit.MONTH,
        isOnlyPrice,
      ),
    [price],
  )

  return { integer, decimal, amountAndDuration }
}
